import { DELETE_DESIGN, GET_DESIGN, UPLOAD_DESIGN } from "./Constants";
import { deleteDesignsApi, getDesignsApi, uploadDesignApi } from "./API";
import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import { deleteDesignFail, deleteDesignSuccess, getDesignsFail, getDesignsSuccess, uploadDesignFail, uploadDesignSuccess } from "./Actions";


function* uploadDesignSaga(payload) {
    try {
        const response = yield call(uploadDesignApi, payload.payload)
        if (response && response.data.status === 1) {
            yield put(uploadDesignSuccess(response.data.message || "New Design Uploaded Succefully!..."))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(uploadDesignFail(error.response.data.error || "Unable to Upload Design"))
    }
}


function* getDesignsSaga() {
    try {
        const response = yield call(getDesignsApi)
        if (response && response.data.status === 1) {
            yield put(getDesignsSuccess(response.data.data || "New Design Uploaded Succefully!..."))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getDesignsFail(error.response.data.error || "Unable to Upload Design"))
    }
}


function* deleteDesignsSaga(payload) {
    try {
        const response = yield call(deleteDesignsApi, payload.payload)
        if (response && response.data.status === 1) {
            yield put(deleteDesignSuccess(response.data.data || "New Design Uploaded Succefully!..."))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(deleteDesignFail(error.response.data.error || "Unable to Upload Design"))
    }
}

function* ManageMarketingToolsSaga() {

    yield takeEvery(UPLOAD_DESIGN, uploadDesignSaga)
    yield takeEvery(GET_DESIGN, getDesignsSaga)
    yield takeEvery(DELETE_DESIGN, deleteDesignsSaga)
  
}

export default ManageMarketingToolsSaga;